/**
 * Lake Charles Terms of Service Page
 *
 * Simple wrapper that imports the parameterized TermsOfServicePage from city-landing-core
 * and passes Lake Charles-specific configuration.
 */

import React from 'react';
import { TermsOfServicePage } from '@core';
import lakeCharlesConfig from '../city.config';

export function LakeCharlesTermsOfServicePage() {
  return (
    <TermsOfServicePage
      cityName={lakeCharlesConfig.identity.cityName}
      stateName={lakeCharlesConfig.identity.stateName}
      companyName="ToolboxLogic"
      // contactEmail="legal@toolboxlogic.com"
      effectiveDate="November 22, 2024"
      cityDomain="lakecharles.toolboxlogic.com"
    />
  );
}
